import { render, staticRenderFns } from "./SendInspectionsReminderEmailAction.vue?vue&type=template&id=e2d82b10&scoped=true&"
import script from "./SendInspectionsReminderEmailAction.vue?vue&type=script&lang=ts&"
export * from "./SendInspectionsReminderEmailAction.vue?vue&type=script&lang=ts&"
import style0 from "./SendInspectionsReminderEmailAction.vue?vue&type=style&index=0&id=e2d82b10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d82b10",
  null
  
)

export default component.exports